import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "上から科目を選択してください。"),
  /*#__PURE__*/_createElementVNode("li", null, "これはデモなので、性能を確かめるのが目的です。この方向で強化して、徐々に実用的なものにしていきます。"),
  /*#__PURE__*/_createElementVNode("li", null, "質問・感想・要望は歓迎です。")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}